/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export * from './WizardStepLabel.component';
